import { ApiErrorCode } from './types';

export class ApiError extends Error {
  public httpCode?: number;
  public errorCode?: ApiErrorCode;
  public data: any;
}
